import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getErrorFormat } from 'core/utils/errors';
import { DeviceTypeWithoutGatewayResponseModel, DeviceTypeWithoutGatewayResponsePayload } from '../models';
import { payloadToDevicesTypesListWithoutGateways } from '../mappers';

const getUrl = ({ host, pageNumber, pageSize }: { host: string; pageNumber: number; pageSize: number }) => {
  const params = new URLSearchParams();
  pageNumber && params.append('page[number]', String(pageNumber));
  pageSize && params.append('page[size]', String(pageSize));

  return `${host}/gateway-cloud/device_types?${params}`;
};

export const GetDevicesTypesListWithoutGateway = async ({
  token,
  host,
  pageNumber,
  pageSize,
}: {
  token: string;
  host: string;
  pageNumber: number;
  pageSize: number;
}): Promise<DeviceTypeWithoutGatewayResponseModel> => {
  try {
    const url = getUrl({ host, pageNumber, pageSize });

    const options: AxiosRequestConfig = {
      url,
      method: 'GET',
      timeout: 10000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '1',
      },
    };

    const { data } = (await axios(options)) as AxiosResponse<DeviceTypeWithoutGatewayResponsePayload>;
    return payloadToDevicesTypesListWithoutGateways(data);
  } catch (error) {
    throw getErrorFormat(error);
  }
};
